export class ClsVerificaInicioModel {
  public UsuarioID: number;
  public EmpresaID: number;
  public NegocioID: number;
  public UsuLogin: string;
  public UsuPass: string;
  public OpcionId: number;
  public Opcion: string;
}
